import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { LotenPage } from '../loten/loten';
import { RestProvider } from '../../providers/rest/rest';
import { ToastHelperProvider } from '../../providers/toast-helper/toast-helper';
// import { Network } from '@ionic-native/network';

/**
 * Generated class for the VerkopenPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-verkopen',
  templateUrl: 'verkopen.html',
})
export class VerkopenPage {
  public auctions: any = [];
  public looseAuctions: any = [];
  public loading: any;
  errorMessage: string;
  dataLoaded: boolean = false;
  failedRequest: boolean = false;

  constructor(public navCtrl: NavController, 
              public navParams: NavParams, 
              public rest: RestProvider, 
              public loadingCtrl: LoadingController, 
              public toastHelper: ToastHelperProvider,
              public alertCtrl: AlertController
              ) {
    
  }

  public ionViewDidLoad(){
    this.loading = this.loadingCtrl.create({
      content: 'Ophalen van verkopen...'
    });
    this.loading.present();
    this.getDataFromCms();
  }

  getDataFromCms(){
    if (!this.rest.checkConnection()) {
      this.presentNoConnectionAlert(this.getDataFromCms.bind(this), this.setFailedRequest);
      return false;
    }    
    this.rest.getAuctions().subscribe((auctions) => {
      if (auctions) {
        this.failedRequest = false;
        this.dataLoaded = true;
        this.loading.dismiss();
        this.auctions = JSON.parse(String(auctions));
        return true;
      }else{
        this.restError();
        return false;
      }
    }, error => {
      this.restError();
      return false;
    });
  }

  setFailedRequest(){
    this.failedRequest = true;
  }

  restError(dismiss = true){
    this.toastHelper.showToast('ERROR: Kon de verkopen niet ophalen.', 'error');
    if(dismiss){this.loading.dismiss()};
    this.failedRequest = true;
  }

  itemClicked(auc){
    this.navCtrl.push(LotenPage, {
      aucId: auc.id,
      aucTitle: auc.title
    });
  }

  looseLotsClicked(){
    this.navCtrl.push(LotenPage, {
      aucId: 999999999,
      loose: true
    });
  }

  doRefresh($event){
    var that = this;
    if (!this.rest.checkConnection()) {
      this.toastHelper.showToast('ERROR: kon geen verbinding maken', 'error');
      $event.complete();
    }else{
      let promise = new Promise(function(resolve, reject) {
        that.rest.getAuctions().subscribe((auctions) => {
          if (auctions) {
            resolve(auctions);
          }else{
            that.restError(false);
            reject('error');
          }
        }, error => {
          that.restError(false);
          reject('error2');
        });
      });
      promise.then(function(auctions){
        that.failedRequest = false;
        that.dataLoaded = true;
        that.auctions = JSON.parse(String(auctions));
        that.toastHelper.showToast('Verkopen opgehaald');
        $event.complete();
      }).catch((err) => {
        this.toastHelper.showToast('ERROR: kon de verkopen niet ophalen.', 'error');
        $event.complete();
      });
    }
  }

  presentNoConnectionAlert(retryCb, cancelCb = null, event = false){
    let alert = this.alertCtrl.create({
      title: 'Geen internet',
      message: 'Kon geen verbinding maken',
      buttons: [
        {
          text: 'Annuleer',
          role: 'cancel',
          handler: () => {
            this.toastHelper.showToast('ERROR: Geen internetverbinding gevonden.', 'error');
            if (cancelCb != null) {
              cancelCb();
            }
            if (!event) {
              this.loading.dismiss();
            }
          }
        },
        {
          text: 'Probeer opnieuw',
          handler: () => {
            if (retryCb) {
              retryCb();
            }
          }
        }
      ]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/verkopen/verkopen.ts